import { SolicitudComercioApi as Api } from "./solicitud-comercio.api";

export class SolicitudComercioFacade {
  static accept(model) {
    return Api.acceptById(model.comercio.id);
  }

  static count() {
    return Api.count();
  }

  static getList(paginationConfig) {
    return Api.getList({ pagination: paginationConfig });
  }

  static reject(model) {
    return Api.rejectById(model.id, model.motivoRechazo);
  }

  static update(model) {
    const dto = {
      comercio: {
        id: model.comercio.id,
        address: model.comercio.address,
        cuit: model.comercio.cuit,
        email: model.comercio.email,
        localidadId: model.comercio.localidad?.id,
        name: model.comercio.name,
        phone: model.comercio.phone
      }
    };

    if (model.beneficio) {
      dto.beneficio = {
        id: model.beneficio.id,
        allowsVisita: model.beneficio.allowsVisita,
        diaHabilitadoList: model.beneficio.diaHabilitadoList,
        discountPercentage: model.beneficio.discountPercentage,
        name: model.beneficio.name,
        payMethod: model.beneficio.payMethod,
        subcategoriaId: model.beneficio.subcategoria?.id
      };
    }

    return Api.update(dto);
  }
}
